<style scoped>
tr {
  border: none;
}

tr:last-child {
  border-top: 1px solid rgb(225, 225, 225);
}

td {
  padding: 5px;
}
</style>

<template lang="pug">
    div
      p.title.small Summary
      table
        tbody
          tr
            td
              span.subtitle.micro Items subtotal
            td.right-align
              span.micro {{$utils.formatter.formatAmount(itemTotal)}}
          tr
            td
              span.subtitle.micro Delivery Fee
            td.right-align
              span.micro {{$utils.formatter.formatAmount(deliveryFee)}}
          tr
            td
              span.subtitle.micro TOTAL
            td.right-align
              span.micro {{$utils.formatter.formatAmount(cartTotal)}}
</template>
<script>
export default {
  computed: {
    itemTotal () {
      return this.$store.getters['cart/itemTotal']
    },
    cartTotal () {
      return parseFloat(this.$store.getters['cart/cartTotal']) + this.deliveryFee
    },
    deliveryFee () {
      return this.$store.state.config.fees
        ? parseFloat(this.$store.state.config.fees.delivery)
        : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-cart-totals.vue